import React from 'react';
import { assign, map } from "lodash";
import PropTypes from 'prop-types';
import BaseCell from '../base-cell/index';
import {getUUID} from '../../../../utils/getUUID';
import * as utils from '../../../../utils/textUtil.js';
import CustomButton from './custom-button';
import { MessageContentWrapper } from "../text-cell/message-content-wrapper.js";
import AvatarIcon from '../../../common/avatarIcon';
import UrlPreviews from '../../../common/urlPreviews';

export default class ButtonCell extends BaseCell {
  constructor (props) {
    super(props);
    this.state = assign({}, BaseCell.mobileTextCopyState);
  }

  componentDidMount() {
    if (this.text && this.props.autoFocus) {
      this.text.classList.add('cu-ui-focus')
      setTimeout(() => this.text.focus());
    }
  }

  render() {
    const {isBot, baseParams, time, text, buttons, buttonLayoutType, iconSrc, withoutDate, systemMessages} = this.props;
    const { textCellStyle, avatarStyle } = this.getCellStyle({isBot, baseParams, iconSrc});

    const modifiedText = utils.prepareTextForRender(text);

    const buttonStyle = {
      color: baseParams.buttonColor,
      backgroundColor: baseParams.buttonBackgroundColor
    };

    return (
      <div className={`${this.messageClass(isBot)} cu-ui-message-button-cell`}
        ref={el => this.box = el}
      >
        <div style={{ display: 'flex', maxWidth: '100%', minHeight: '1px' }}>
          <div className={'cu-ui-message-block cu-ui-text-count-data'} { ...this.textCountCustomAttributes }>
            <div className={'cu-ui-message-avatar'} style={avatarStyle}>
              { !(isBot || iconSrc && iconSrc.length !== 0) && <AvatarIcon />}
            </div>
            <div className={this.messageContentClass({'cu-ui-message-buttons': true})}
              data-testid="content"
              style={textCellStyle}
              onTouchStart={this.showMessageContentWrapperD}
              onTouchMove={this.clearShowMessageContentWrapperD}
              onTouchEnd={this.clearShowMessageContentWrapperD}
            >
              <div ref={el => this.text = el}
                data-testid="text"
                style={{marginBottom: 10}}
                dangerouslySetInnerHTML={{ __html: modifiedText }}
                onTouchStart={e => e.stopPropagation()}
                onBlur={() => this.text.classList.remove('cu-ui-focus')}
                tabIndex="0"
              />
              { this.renderButton(buttons, buttonLayoutType, buttonStyle) }
              <MessageContentWrapper
                show={this.state.showMessageContentWrapper}
                wrapperDiv={this.box}
                systemMessages={systemMessages}
                onCopy={e => this.executeCopy(e, this.text)}
                onCancel={this.hideMessageContentWrapper}
              />
            </div>
          </div>
          {
            !withoutDate && <div className={'cu-ui-message-time'}>{time}</div>
          }
        </div>
        {
          (this.props.canUnfurl && this.props.text) &&
          <UrlPreviews text={this.props.text} />
        }
      </div>
    );
  }

  renderButton(buttons, buttonLayoutType, style) {
    const { buttonLabelAlign } = this.props;

    switch (buttonLayoutType) {
      case 'block':
        return map(buttons, (b) => {
          return <CustomButton button={b} buttonType={'wide'} key={getUUID()} style={style} textAlign={buttonLabelAlign} />;
        });
      case 'flex':
        return (
          <div className={'cu-ui-button-group cu-ui-block'}>
            {
              map(buttons, (b) => {
                return <CustomButton button={b} buttonType={'block'} key={getUUID()} style={style} textAlign={buttonLabelAlign} />;
              })
            }
          </div>
        );
    }
  }
}

ButtonCell.propTypes = {
  isBot: PropTypes.bool,
  time: PropTypes.string,
  text: PropTypes.string,
  buttonLayoutType: PropTypes.string,
  buttons: PropTypes.array,
  iconSrc: PropTypes.string,
  canUnfurl: PropTypes.bool,
  buttonLabelAlign: PropTypes.string,
};
